import { ImportGridComponent } from './import-grid.component';
export * from './import-grid.component';

export const COMPONENTS = [
  ImportGridComponent
];
